import {AfterViewChecked, Directive, ElementRef, HostListener, Input} from "@angular/core";

@Directive({
  selector: '[myMatchHeight]'
})
export class MatchHeightDirective implements AfterViewChecked {

  @Input() myMatchHeight: string;

  constructor(private el: ElementRef) {
  }

  ngAfterViewChecked(): void {
    this.matchHeight(this.el.nativeElement, this.myMatchHeight);
  }

  matchHeight(parent: HTMLElement, className: string) {
    if (!parent) {
      return;
    }

    const children = parent.getElementsByClassName(className);

    if (!children) {
      return;;
    }

    Array.from(children).forEach((el: HTMLElement) => el.style.height = 'initial');

    const itemHeights = Array.from(children).map(x => x.getBoundingClientRect().height);

    const maxHeight = itemHeights.reduce((prev, curr) => {
      return curr > prev ? curr : prev;
    });

    Array.from(children).forEach((el: HTMLElement) => el.style.height = `${maxHeight}px`);
  }

  @HostListener('window:resize')
  onResize() {
    this.matchHeight(this.el.nativeElement, this.myMatchHeight);
  }
}
